module.exports = __webpack_public_path__ + "img/value_report_lists_no.e9dc37f7.png";